import { Button, Colors, Display, Sizes } from 'Views/Components/Button/Button'
import If from 'Views/Components/If/If';
import { PaymentMethodModal } from './PaymentMethodModal';
import { useState } from 'react';
import { OrganisationEntity } from 'Models/Entities';
import { store } from 'Models/Store';
import { CustomerPaymentMethodDetails } from 'Hooks/Api/apiStripe';

type Props = {
	paymentMethodDetails: CustomerPaymentMethodDetails | null;
	organisation: OrganisationEntity;
	businessEntityId?: string | undefined;
}


enum PaymentMethodBrands {
	amex = "American Express",
	diners = "Diners Club",
	discover = "Discover",
	eftpos_au = "EFTPOS",
	jcb = "JCB",
	mastercard = "Mastercard",
	unionpay = "UnionPay",
	visa = "Visa",
	unknown = "Unknown card"
}

export const PaymentMethodField = ({
	paymentMethodDetails,
	organisation,
	businessEntityId
}: Props) => {
	const [paymentMethodModalOpen, setPaymentMethodModalOpen] = useState(false);

	let redirectUrl = !businessEntityId
		? '/hub/organisation/billing'
		: `/hub/organisation/business-entities/${businessEntityId}/billing`

	if (store.userType === 'SUPER_USER') {
		redirectUrl = !businessEntityId
			? `/hub/clients/${organisation.id}/billing`
			: `/hub/clients/${organisation.id}/business-entities/${businessEntityId}/billing`
	}

	return (
		<div className="billing-field">
			<div className="billing-field__title">
				<div className="header">
					<h6>Payment Method</h6>
					{!paymentMethodDetails && (<p className="description">No payment method configured</p>)}
					{paymentMethodDetails && (
						<p className='description'>
							{PaymentMethodBrands[
								paymentMethodDetails.brand as keyof typeof PaymentMethodBrands
							]} ending in {paymentMethodDetails.lastFourDigits}
						</p>
					)}
				</div>
				<div className="actions">
					<If condition={!!paymentMethodDetails}>
						<Button
							display={Display.Outline}
							sizes={Sizes.Small}
							colors={Colors.None}
							onClick={() => setPaymentMethodModalOpen(true)}
						>
							Edit payment method
						</Button>
					</If>
					<If condition={!paymentMethodDetails}>
						<Button
							display={Display.Outline}
							sizes={Sizes.Small}
							colors={Colors.None}
							onClick={() => setPaymentMethodModalOpen(true)}
						>
							Add payment method
						</Button>
					</If>
				</div>
			</div>
			<If condition={paymentMethodModalOpen}>
				<PaymentMethodModal
					organisation={organisation}
					businessEntityId={businessEntityId}
					onClose={() => setPaymentMethodModalOpen(false)}
					redirectUrl={redirectUrl}
				/>
			</If>
		</div>
	)
}